/**
 * BANNER SERVICE - API ABSTRACTION LAYER
 *
 * Single import point for all Banner/Content Management API operations.
 *
 * USAGE:
 *   import { bannerService } from '@/app/services/api/content/bannerService';
 *   const banners = await bannerService.banners.getAll();
 */

import * as bannerClient from './bannerClient';

export const bannerService = {
  banners: {
    getAll: bannerClient.getAllBanners,
    getById: bannerClient.getBannerById,
    create: bannerClient.createBanner,
    update: bannerClient.updateBanner,
    delete: bannerClient.deleteBanner,
    uploadImage: bannerClient.uploadBannerImage,
  },

  storefront: {
    getBanners: bannerClient.getStorefrontBanners,
  },

  assignments: {
    assign: bannerClient.assignBannerToSlot,
    remove: bannerClient.removeAssignment,
  },

  slots: {
    getAll: bannerClient.getAllSlots,
    create: bannerClient.createSlot,
    update: bannerClient.updateSlot,
    delete: bannerClient.deleteSlot,
  },
};
